var isSearchIconViewable = function isSearchIconViewable(_ref) {
  var isActive = _ref.state.isActive;
  return !isActive;
};
var isClearIconViewable = function isClearIconViewable(_ref2) {
  var isClearable = _ref2.props.isClearable,
    isActive = _ref2.state.isActive;
  return isClearable && isActive;
};
var ExpandableSearchReader = {
  isSearchIconViewable: isSearchIconViewable,
  isClearIconViewable: isClearIconViewable
};
export default ExpandableSearchReader;